import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { TabError } from '@/utils/class/TabError'
import ColumnUtils from '@/utils/ColumnUtils'
import { getObjectByCache } from '@/utils/basicDataCache'
import * as CargoSource from '@/class/cargo/model/parameters/CargoSource'
import { AirExportUtils } from '@/class/cargo/model/utils/AirExportUtils'
import { ImportConstants } from '@/class/cargo/model/utils/ImportConstants'
import { User } from '@/class/model/sys/User'
import { Office } from '@/class/model/sys/Office'
import { Company } from '@/class/model/mdm/Company'
import { Contract } from '@/class/model/mdm/Contract'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { OverseaCustomerUtils } from '@/class/cargo/model/utils/OverseaCustomerUtils'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { checkPoNoIsExist } from '@/api/booking/job'
import * as CargoOfRoleType from '@/class/cargo/model/parameters/CargoOfRoleType'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { cache } from '@/utils/cacheManager'

export default {
  methods: {
    onShow(row, isRefresh) {
      if (!row.uuid) { // 新增时，重置主单号
        this.mblCode = ''
        this.mblNum = ''
        this.mblCodeNumValidate = true
      }
      if (!isRefresh) {
        return
      }
      /* ****************************** 配置 begin ****************************** */
      this.isHC = String(this.context.config.get('ToExoSystem')) === 'HC'
      this.salesOfficeCheck = Number(this.context.config.get('SalesOfficeCheck')) === 1
      this.isSpecifiedSalesBusiness = Number(this.context.config.get('IsSpecifiedSalesBusiness')) === 1
      this.branchOfficeCheck = Number(this.context.config.get('departmentSalesOfficeCheck')) === 1
      this.needConfirmProjectNo = Number(this.context.config.get('needConfirmProjectNo')) === 1
      this.isZY = String(this.context.config.get('ToExoSystem')) === 'zy' // 显示中邮选项
      this.isShowContactPersonDetail = String(this.context.config.get('ToExoSystem')) === 'HC'
      /* ****************************** end ****************************** */
      this.txtSalesOffice = ''
      for (const key in this.userPortRoleData) {
        this.userPortRoleData[key] = null
      }
      this.job = row
      if (row.customerId > 0) {
        Company.getCompanyById(row.customerId).then(async company => {
          this.contactList = await new Company(company).getContacts()
        })
      }
      this.mblCode = row.mbl.substr(0, 3)
      this.mblNum = row.mbl.substr(3)
      this.onMblCodeNumBlur()
      if (row.salesOffice) {
        this.txtSalesOffice = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', row.salesOffice, 'chineseName')
      }
      OverseaCustomerUtils.loadOverseaAgentChanged(this)
      if (!this.isEdit && this.job.poNo && this.needConfirmProjectNo) {
        checkPoNoIsExist(this.job.poNo, this.job.uuid).then(res => { this.poNoRed = (res.data > 0) })
      }
      if (!this.job.uuid) {
        JobUtils.matchUserPortConfig(this, this.job)
        JobUtils.matchRegionWarehouseMappingConfig(this.job, null, false, null, null, true)
      } else {
        JobUtils.matchUserPortConfig(this, this.job, false, null, { keepOriginValue: true })
      }
      JobUtils.loadCompanyCargoSales(this, this.job, this.isSpecifiedSalesBusiness)
    },
    async cargoSource_Change(obj) {
      this.setJobSelectValue(obj)
      this.job.designationAgent = 0
      if (this.job.cargoSource === CargoSource.SC_CARGO_SOURCE.code) {
        const company = Company.getCompanyByIdSync(this.job.customerId)
        if (company) {
          await this.loadCompanyUser(company)
        }
      } else {
        this.salesList = null
      }
      await OverseaCustomerUtils.designationAgentOrCargoSourceChangeHandler(this)
    },
    setJobSelectValue(obj) {
      this.job[obj.key] = obj.value
    },
    setJobSelectNum(obj) {
      this.job[obj.key] = obj.value || 0
    },
    async designationAgentChangeHandler(company) {
      if (!company.cmpIdx) {
        this.job.designationAgent = 0
        this.job.sales = 0
        await OverseaCustomerUtils.designationAgentOrCargoSourceChangeHandler(this)
        return
      }
      this.job.designationAgent = company.cmpIdx
      const overseaAgentDetail = await new Company({ uuid: company.uuid }).getOverseaAgentDetail()
      if (overseaAgentDetail) {
        this.job.sales = 0
        if (this.salesOfficeCheck) {
          for (const option of this.$refs.sales.options) {
            if (option.userId === overseaAgentDetail.owner && option.active) {
              this.job.sales = overseaAgentDetail.owner
              break
            }
          }
        } else {
          this.job.sales = overseaAgentDetail.owner
        }
      }
      await OverseaCustomerUtils.designationAgentOrCargoSourceChangeHandler(this)
    },
    async txtCustomerId_changeHandler(company) {
      this.contactList = []
      this.cargoSalesList = null
      this.job.customerContact = ''
      this.job.contactTelephone = ''
      this.job.contactFax = ''
      if (!company.cmpIdx) {
        this.job.customerId = 0
        return
      }
      // 中邮委托单位是否黑名单
      const blacklist = await JobUtils.checkBlacklistByCustomerId(company.cmpIdx)
      if (blacklist) {
        // return
      }
      this.job.customerId = company.cmpIdx
      const isForbid = await Contract.isContractExpiredForbidCreateJob(company.cmpIdx)
      if (isForbid) {
        this.job.customerId = 0
        this.$message.info(this.$t('Message.ContractExpireCannotCreated'))
        return
      }
      const cmpModel = new Company({ uuid: company.uuid })
      cmpModel.getContacts().then(contactList => {
        this.contactList = contactList
        const contact = this.getDefaultContact(this.contactList)
        if (contact) {
          this.job.customerContact = contact.contactPerson
          this.job.contactTelephone = contact.telephone
          this.job.contactFax = contact.fax
        }
      })
      await this.loadCompanyUser(company)
      JobUtils.loadCompanyCargoSales(this, this.job, this.isSpecifiedSalesBusiness, true)
      if (company && company.incoTerm) {
        const incoTerm = company.incoTerm.split(',')
        if (incoTerm.length > 0) {
          this.job.incoTerm = incoTerm[0]
        }
      }
    },
    getDefaultContact(contactList) {
      if (!contactList || contactList.length <= 0) return ''
      const c = contactList.find(item => item.defaultContact)
      return c || contactList[0]
    },
    async loadingAgentChangeHandler(company) {
      if (!company.cmpIdx) {
        this.job.loadingAgentId = 0
        await OverseaCustomerUtils.destinationAgentChangeHandler(this)
        return
      }
      this.job.loadingAgentId = company.cmpIdx
      await OverseaCustomerUtils.destinationAgentChangeHandler(this)
    },
    txtCarrierId_changeHandler(obj) {
      this.setJobSelectNum(obj)
      const cmpModel = new Company({ uuid: obj.uuid })
      cmpModel.getAirlineDetail().then(data => {
        if (data) {
          this.mblCode = data.mawbprefix
        } else {
          this.mblCode = ''
        }
      })
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job)
    },
    onMblCodeInput(value) {
      this.mblCode = value
      if (this.mblCode.length === 3) {
        this.$refs.mblNum.$refs.cargoInput.focus()
      }
    },
    onMblCodeNumBlur() {
      const codeNum = this.mblCode + this.mblNum
      if (codeNum) {
        if (AirExportUtils.validateMAWBNum(codeNum)) {
          this.mblCodeNumValidate = true
        } else {
          this.mblCodeNumValidate = false
        }
        this.fillMBL()
      } else {
        this.mblCodeNumValidate = true
      }
    },
    fillMBL() {
      const job = this.job
      if (!job.express) {
        if (this.mblCode.length === 3 && !this.mblNum) {
          job.mbl = this.mblCode.replace(/-/g, '')
        } else {
          job.mbl = this.mblCode.replace(/-/g, '')
          if (this.mblNum) {
            job.mbl += this.mblNum
          }
        }
      }
    },
    filterNonDigit(value) {
      return value.replace(/[^\d]/g, '')
    },
    dischargingPortCode_Change(data) {
      this.job.dischargingPortCode = data.value
      this.job.destinationPortCode = data.value
      if (data.value) {
        this.job.destinationPlace = data.englishName
      }
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job)
    },
    // 单号抄录
    async onExcerptionChangeFunc(data) {
      this.job.shipperCode = data.shipperCode
      this.job.shipperLine1 = data.shipperLine1
      this.job.consigneeCode = data.consigneeCode
      this.job.consigneeLine1 = data.consigneeLine1
      this.job.notifyCode = data.notifyCode
      this.job.notifyLine1 = data.notifyLine1
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitShipperLine(data.shipperInfo)
        this.job.shipperCode = data.shipperCode
      }
      if (data.consigneeInfo) {
        this.splitConsigneeLine(data.consigneeInfo)
        this.job.consigneeCode = data.consigneeCode
      }
      if (data.notifyInfo) {
        this.splitNotifyLine(data.notifyInfo)
        this.job.notifyCode = data.notifyCode
      }
    },
    mergeShipperLine() {
      let result = ''
      if (this.job['shipperLine1']) {
        for (let i = 1; i < 7; ++i) {
          result += this.job['shipperLine' + i] || ''
          result += '\n'
        }
        result += (this.job['shipperLine7'] || '')
      }
      return result.trimEnd()
    },
    splitShipperLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['shipperLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['shipperLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.job['shipperLine' + i] = ''
      }
    },
    mergeConsigneeLine() {
      let result = ''
      if (this.job['consigneeLine1']) {
        for (let i = 1; i < 7; ++i) {
          result += this.job['consigneeLine' + i] || ''
          result += '\n'
        }
        result += (this.job['consigneeLine7'] || '')
      }
      return result.trimEnd()
    },
    splitConsigneeLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['consigneeLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['consigneeLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.job['consigneeLine' + i] = ''
      }
    },
    mergeNotifyLine() {
      let result = ''
      if (this.job['notifyLine1']) {
        for (let i = 1; i < 7; ++i) {
          result += this.job['notifyLine' + i] || ''
          result += '\n'
        }
        result += (this.job['notifyLine7'] || '')
      }
      return result.trimEnd()
    },
    splitNotifyLine(val) {
      let fromIndex = 0
      let i = 1
      for (; i < 7; ++i) {
        const index = val.indexOf('\n', fromIndex)
        if (index === -1) {
          break
        }
        this.job['notifyLine' + i] = val.substring(fromIndex, index)
        fromIndex = index + 1
      }
      this.job['notifyLine' + i] = val.substring(fromIndex)
      for (++i; i < 8; ++i) {
        this.job['notifyLine' + i] = ''
      }
    },
    showAdvanceTextDialog(title, value, textChars, successCallback, isUppercase = true) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.isUppercase = isUppercase
      this.advanceTextDialog.textChars = textChars
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.visible = true
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    /**
     * 计算计费重量
     * 空运体积和重量的换算是体积（立方米）/0.006=体积重量（公斤）
     * 体积重量大于实际重量时候，计费重量就是体积重量
     * 体积重量小于实际重量的时候，计费重量就是实际重量
     * 0.1《尾数《0.5，则应为进位到0.5
     * 0.5《尾数《1则应进位到1
     */
    calculateChargeWeight() {
      this.job.cubageContract = this.job.cubageActual
      this.job.weightContract = this.job.weightActual
      const job = this.job
      const chargeWeight = job.cubageContract / 0.006
      let value = ''
      if (chargeWeight > job.weightContract) {
        value = ImportConstants.toFixed2(chargeWeight, 1)
      } else {
        value = ImportConstants.toFixed2(job.weightContract, 1)
      }
      job.chargeWeight = Number(value)
    },
    quantityContractCharge() {
      this.job.quantityContract = this.job.quantityActual
    },
    // 当选择销售人员的时候自动关联该销售所在分公司
    async salesChangeHandler(data) {
      const job = this.job
      job.sales = data.value
      job.salesOffice = 0
      this.txtSalesOffice = ''
      job.salesDepartment = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'sales', data.value)
        if (offices.length > 1) {
          for (const item of offices) {
            if (this.branchOfficeCheck || (!this.branchOfficeCheck && item.officeId === this.context.office.officeId)) {
              job.salesOffice = item.officeId
              job.salesDepartment = item.departmentId
              this.txtSalesOffice = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', job.salesOffice, 'chineseName')
              break
            }
          }
        } else {
          const user = new User(data)
          const department = await user.getDefaultDepartment('role', 'sales')
          job.salesDepartment = department ? department.departmentId : 0
          const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
          if (office) {
            job.salesOffice = office.officeId
            this.txtSalesOffice = office.chineseName
          }
        }
      }
    },
    departmentChangeHandler(department) {
      if (!department.departmentId) {
        this.job.salesDepartment = 0
        return
      }
      this.job.salesDepartment = department.departmentId
      const office = getObjectByCache(TYPE_NAMES.basic_data_Office_All, 'uuid', department.officeUuid)
      if (office && office.officeId !== this.job.salesOffice) {
        this.job.salesOffice = office.officeId
        this.txtSalesOffice = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', office.officeId, 'chineseName')
      }
    },
    // 操作改变
    opChangeHandler(data) {
      const job = this.job
      job.op = data.value
      data.opDepartment = 0
      if (data.value) {
        if (job.opOffice > 0) {
          new User({ ...data }).getUserDefaultDepartmentByOffice('role', 'op', job.opOffice).then(dep => {
            job.opDepartment = dep ? dep.departmentId : 0
          })
        } else {
          new User({ ...data }).getDefaultDepartment('role', 'op', job.opOffice).then(dep => {
            job.opDepartment = dep ? dep.departmentId : 0
          })
        }
      }
    },
    /**
     * 客服改变
     */
    async csrChangeHandler(data) {
      const job = this.job
      job.csr = data.value
      job.csrDepartment = 0
      job.csrOffice = 0
      if (data.value) {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'csr')
        if (dep) {
          job.csrDepartment = dep.departmentId
          const office = await Office.getOfficeByUuid(dep.officeUuid)
          job.csrOffice = office ? office.officeId : 0
        }
      }
    },
    async dcChangeHandler(data) {
      const job = this.job
      job.dc = data.value
      job.dcDepartment = 0
      job.dcOffice = 0
      if (data.value) {
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'doc')
        job.dcDepartment = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.dcOffice = office ? office.officeId : 0
      } else {
        job.dc = 0
        job.dcDepartment = 0
        job.dcOffice = 0
      }
    },
    /**
     * 航线改变
     */
    async plannerChangeHandler(data) {
      const job = this.job
      if (data.value) {
        job.planner = data.value
        const user = new User(data)
        const dep = await user.getDefaultDepartment('role', 'seaLine')
        job.plannerDepartment = dep ? dep.departmentId : 0
        const office = dep ? await Office.getOfficeByUuid(dep.officeUuid) : null
        job.plannerOffice = office ? office.officeId : 0
      } else {
        job.planner = 0
        job.plannerDepartment = 0
        job.plannerOffice = 0
      }
    },
    endTabHandler() {
      this.fillModel()
    },
    fillModel() {
      const job = this.job
      job.jobState = -1
      job.masterFlag = false
      job.opOffice = this.$store.getters.currentOfficeId
      job.lob = 'AI'
      job.signHBL = true
      job.signMBL = true
      job.booking = true
      if (!job.express) {
        this.job.mbl = this.mblCode
        if (this.mblNum) {
          this.job.mbl += this.mblNum
        }
      }
      job.shipperId = 0
      job.consigneeId = 0
      job.notifyId = 0
      if (!job.op) {
        job.op = this.$store.getters.userId
      }
      if (parseInt(this.context.config.get('syncMailingAddress')) === 1) {
        ImportConstants.saveBillAddress(job)
      }
    },
    async getSubmitData() {
      await this.validateForm()
      return {
        job: this.job
      }
    },
    async validateForm() {
      const form = this.job
      if (form.customerId < 1) {
        if (form.cargoSource === 'NC') {
          throw new TabError(this.$t('queryJob.ActualNotifierCannotBeBlank'), 'tabBookingFCL')
        } else {
          throw new TabError(this.$t('Message.ConsignationCompanyCannotBeNull'), 'tabBookingFCL')
        }
      }
      await JobUtils.checkCustomerBranchScope(form, 'tabBookingFCL')
      if (!form.eta) {
        throw new TabError(this.$t('queryJob.ExpectedArrivalDateCannotBlank'), 'tabBookingFCL')
      }
      if (!form.loadingPortCode) {
        throw new TabError(this.$t('Message.POLCannotBeNull'), 'tabBookingFCL')
      }
      if (!form.dischargingPortCode) {
        throw new TabError(this.$t('Message.PortOfDestinationCannotBeNull'), 'tabBookingFCL')
      }
      if (form.cargoSource === CargoSource.SC_CARGO_SOURCE.code && form.sales === 0) {
        throw new TabError(this.$t('Message.SalesCannotBeNull'), 'tabBookingFCL')
      }
      if (!SecurityUtil.customerIsOwn(form.customerId) && !form.uuid) {
        throw new TabError(this.$t('CargoMsg.Cargo_CustomerNotOwn'), 'tabBookingFCL')
      }
      // 中邮定制字段 保存校验
      if (this.isZY && !form.saleProductCode) {
        throw new TabError(this.$t('Message.SaleProductCodeCannotBeNull'), 'tabBookingFCL')
      }
      if (this.isZY && !form.fullOrInside) {
        throw new TabError(this.$t('Message.FullOrInsideCannotBeNull'), 'tabBookingFCL')
      }
    },
    // 组装打印参数
    getPrintData() {
      return { JOB_UUID: this.job.uuid, category: 'AIJOBNO', ctx: new AirImportJob(this.job) }
    },
    async cargoSalesChargeHandler(data) {
      const job = this.job
      job.cargoSalesId = data.value || 0
      job.cargoSalesDepartment = 0
      job.cargoSalesOffice = 0
      if (data.value) {
        const offices = await User.getUserDepartmentOffices('role', 'salesOfGoods', data.value)
        if (offices && offices.length > 1) {
          for (const item of offices) {
            if (item.officeId === this.context.office.officeId) {
              const office = await Office.getOfficeById(item.officeId)
              job.cargoSalesOffice = office ? office.officeId : 0
              job.cargoSalesDepartment = item.departmentId
              break
            }
          }
        } else {
          const user = new User(data)
          const department = await user.getDefaultDepartment('role', 'salesOfGoods')
          if (department) {
            job.cargoSalesDepartment = department ? department.departmentId : 0
            const office = department ? await Office.getOfficeByUuid(department.officeUuid) : null
            job.cargoSalesOffice = office ? office.officeId : 0
          }
        }
      }
    },
    // 加载合作伙伴维护的岗位人员信息
    async loadCompanyUser(company) {
      if (this.isSpecifiedSalesBusiness) { // IsSpecifiedSalesBusiness参数开启
        const companyUsers = await Company.getCompanyUsers(company.uuid)
        const job = this.job
        // 销售
        const salesList = []
        let salesDefaultId = 0
        // 揽货销售
        const cargoSalesList = []
        let cargoSalesId = 0
        // 操作
        const opList = []
        let opDefaultId = 0
        // 海外客服
        const overseaOpList = []
        let overseaOpDefaultId = 0
        // 如果开启分公司过滤参数，查出来所有分公司
        let officeSaleList = []
        if (this.salesOfficeCheck) {
          officeSaleList = await User.getUsersByPrivilegeDetail('role', 'sales', '', this.$store.getters.currentOfficeId)
        }
        if (companyUsers && companyUsers.length > 0) {
          for (const u of companyUsers) {
            if (!u.lob || u.lob === job.lob || u.lob === 'ALL') {
              const user = this.context.userList.find(p => p.userId === u.userId)
              if (user && user.active) {
                if (u.roleType === CargoOfRoleType.SALES_TYPE.code) { // 销售
                  if (this.salesOfficeCheck) {
                    for (const obj of officeSaleList) {
                      if (user.userId === obj.userId) {
                        if (u.defaultUser) {
                          salesDefaultId = u.userId
                        }
                        salesList.push(user)
                      }
                    }
                  } else {
                    if (u.defaultUser) {
                      salesDefaultId = u.userId
                    }
                    salesList.push(user)
                  }
                } else if (u.roleType === CargoOfRoleType.SALES_OF_GOODS.code) { // 揽货销售
                  if (u.defaultUser) {
                    cargoSalesId = u.userId
                  }
                  cargoSalesList.push(user)
                } else if (u.roleType === CargoOfRoleType.OP_TYPE.code) { // 操作
                  if (u.defaultUser) {
                    opDefaultId = u.userId
                  }
                  opList.push(user)
                } else if (u.roleType === CargoOfRoleType.OVERSEAOP_TYPE.code) { // 海外客服
                  if (u.defaultUser) {
                    overseaOpDefaultId = u.userId
                  }
                  overseaOpList.push(user)
                }
              }
            }
          }
        }
        if (job.cargoSource !== CargoSource.NC_CARGO_SOURCE.code) {
          // 销售
          this.salesList = salesList
          if (salesList.length > 0) {
            if (salesDefaultId > 0) {
              job.sales = salesDefaultId
            } else {
              job.sales = salesList[0].userId
            }
            if (job.sales) {
              const user = User.getUserByIdSync(job.sales)
              if (user && user.active) {
                await this.salesChangeHandler({ ...user, value: user.userId })
              }
            }
          } else {
            // job.sales = 0
            // job.salesDepartment = 0
            // job.salesOffice = 0
            // this.txtSalesOffice = ''
          }
        }
        // 揽货销售
        if (cargoSalesList.length > 0) {
          if (cargoSalesId > 0) {
            job.cargoSalesId = cargoSalesId
          } else {
            job.cargoSalesId = cargoSalesList[0].userId
          }
          if (job.cargoSalesId) {
            const user = User.getUserByIdSync(job.cargoSalesId)
            if (user && user.active) {
              await this.cargoSalesChargeHandler({ ...user, value: user.userId })
            }
          }
        } else {
          // job.cargoSalesId = 0
          // job.cargoSalesOffice = 0
          // job.cargoSalesDepartment = 0
        }
        if (this.isHC) {
          // 操作
          if (opList.length > 0) {
            if (opDefaultId > 0) {
              job.op = opDefaultId
            } else {
              job.op = opList[0].userId
            }

            const user = await User.getUserById(job.op)
            this.$nextTick(() => {
              this.opChangeHandler({ ...user, value: user.userId })
            })
          } else {
            // job.op = 0
            // job.opDepartment = 0
          }
          // 海外客服
          if (overseaOpList.length > 0) {
            if (overseaOpDefaultId > 0) {
              job.overseaOp = overseaOpDefaultId
            } else {
              job.overseaOp = overseaOpList[0].userId
            }

            const user = await User.getUserById(job.overseaOp)
            this.$nextTick(() => {
              OverseaCustomerUtils.overseaOpChangeHandler(this, { ...user, value: user.userId })
            })
          } else {
            // job.overseaOp = 0
            // job.overseaOpDepartment = 0
          }
        }
      } else { // IsSpecifiedSalesBusiness参数关闭
        if (this.job.cargoSource === CargoSource.SC_CARGO_SOURCE.code && !this.job.masterFlag) { // 非主票且为自揽货
          const customer = await new Company(company).getCustomerDetail()
          if (customer) {
            if (customer.sales > 0) {
              const salesTemp = customer.sales
              const user = User.getUserByIdSync(salesTemp)
              if (user && user.active) {
                if (this.salesOfficeCheck) {
                  this.job.sales = 0
                  for (const option of this.$refs.sales.options) {
                    if (option.userId === salesTemp) {
                      this.job.sales = salesTemp
                    }
                  }
                } else {
                  this.job.sales = salesTemp
                }
                await this.salesChangeHandler(this.job.sales > 0 ? { ...user, value: salesTemp } : { value: 0 })
              }
            } else {
              // this.job.sales = 0
              // this.job.salesOffice = 0
              // this.job.salesDepartment = 0
              // this.txtSalesOffice = ''
            }
          }
        }
      }
    },
    loadingPortCodeChange(data) {
      this.setJobSelectValue(data)
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job)
    },
    opOfficeChargeHandler() {
      JobUtils.opOfficeChange({ view: this, job: this.job })
    },
    onOperateTypeChange(obj) {
      this.setJobSelectValue(obj)
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job)
    },
    onCustomJobTypeChange(obj) {
      this.setJobSelectValue(obj)
      JobUtils.matchUserPortConfig(this, this.job)
      JobUtils.matchRegionWarehouseMappingConfig(this.job)
    },
    // 设置操作分公司
    setOpOffice(val) {
      this.job.opOffice = val
    },
    onCargoTypeChagne(data) {
      this.setJobSelectValue(data)
      JobUtils.matchUserPortConfig(this, this.job)
    }
  }
}
